export default {"src":"/_next/static/media/experiment.aa5ce95d.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};